export class MoedasModel {
  id: number;
  nome: string;
  iniciais: string;
  iso: string;
}



// WEBPACK FOOTER //
// ./src/app/moedas/moedas.model.ts